module.exports = __webpack_public_path__ + "images/emoji/crystal_ball.eb2018cb8cc7d7485a3d.png";